/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCarveOutRequest
 */
export interface CreateCarveOutRequest {
    /**
     * 
     */
    lead_medication_id?: string;
    /**
     * 
     */
    medication_name: string;
    /**
     * 
     */
    dosage?: string;
    /**
     * 
     */
    route?: string;
    /**
     * 
     */
    frequency?: string;
    /**
     * 
     */
    cost_per_day?: number;
    /**
     * 
     */
    j_code?: string;
    /**
     * 
     */
    ndc?: string;
    /**
     * 
     */
    stop_date?: string;
    /**
     * 
     */
    notes?: string;
}

/**
 * Check if a given object implements the CreateCarveOutRequest interface.
 */
export function instanceOfCreateCarveOutRequest(value: object): value is CreateCarveOutRequest {
    if (!('medication_name' in value) || value['medication_name'] === undefined) return false;
    return true;
}

export function CreateCarveOutRequestFromJSON(json: any): CreateCarveOutRequest {
    return CreateCarveOutRequestFromJSONTyped(json, false);
}

export function CreateCarveOutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCarveOutRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_medication_id': json['lead_medication_id'] == null ? undefined : json['lead_medication_id'],
        'medication_name': json['medication_name'],
        'dosage': json['dosage'] == null ? undefined : json['dosage'],
        'route': json['route'] == null ? undefined : json['route'],
        'frequency': json['frequency'] == null ? undefined : json['frequency'],
        'cost_per_day': json['cost_per_day'] == null ? undefined : json['cost_per_day'],
        'j_code': json['j_code'] == null ? undefined : json['j_code'],
        'ndc': json['ndc'] == null ? undefined : json['ndc'],
        'stop_date': json['stop_date'] == null ? undefined : json['stop_date'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function CreateCarveOutRequestToJSON(json: any): CreateCarveOutRequest {
    return CreateCarveOutRequestToJSONTyped(json, false);
}

export function CreateCarveOutRequestToJSONTyped(value?: CreateCarveOutRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_medication_id': value['lead_medication_id'],
        'medication_name': value['medication_name'],
        'dosage': value['dosage'],
        'route': value['route'],
        'frequency': value['frequency'],
        'cost_per_day': value['cost_per_day'],
        'j_code': value['j_code'],
        'ndc': value['ndc'],
        'stop_date': value['stop_date'],
        'notes': value['notes'],
    };
}

